import * as React from 'react';
import classNames from 'classnames';
import { useTheme } from '../useTheme';
import { Classes } from '../index';

type Props = {
  // Class name pro akce (dialog actions)
  className?: string;
  // Class name pro footer
  wrapperClassName?: string;
};

export const DialogFooter: React.FC<Props> = ({
  wrapperClassName,
  className,
  children,
}) => {
  const theme = useTheme();

  let wrapperCls = classNames(
    `${theme.ns}`,
    wrapperClassName,
    Classes.DIALOG_FOOTER
  );

  let actionsCls = classNames(
    `${theme.ns}`,
    className,
    Classes.DIALOG_FOOTER_ACTIONS
  );

  return (
    <div className={wrapperCls}>
      <div className={actionsCls}>{children}</div>
    </div>
  );
};
